import { TimeRangePickerProps } from "antd";
import imageCompression from "browser-image-compression";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment-timezone";
import { getBusinessTimeZone } from "./moment";
import { useEffect, useState } from "react";
import { svg } from "../Assets/svg";
import DefaultProfile from "../Assets/Images/DefaultProfile.png";
import { RootState, useAppSelector } from "../store";
import { SortOrder } from "antd/es/table/interface";
import { DecriptEnv } from "./cryptoConfig";
import { allCommonImages } from "../Assets/Images/images";
import store from "../store";
import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";

export { DecriptEnv, responseEncrypted, secretKey } from "./cryptoConfig";

// import { AxiosErrorResponse, Scope } from "../Enum/utilsEnum";

export const DATABASE_SCHEMA_VERSION = 1; // Manually increment this when SQLite schema changes

//** Function to get AWS secret access key */
export const getS3SecretAccessKey = (value: string) => {
  const finalKey = value!.slice(6, 46);
  return finalKey;
};

//** Function to get Captcha secret key */
export const getCAPTCHASecretKey = (value: string) => {
  const finalKey = value!.slice(12, 52);
  return finalKey;
};
export const alias = process.env.REACT_APP_ALIAS || "";

/**
 * REACT_APP_ENABLE_WEB_ATTENDANCE — master switch for allowing the
 * Attendance Tablet role to log in and clock in/out from web browsers.
 *
 *  - "true" / "1" → web attendance enabled (dev servers only).
 *  - missing / "false" / "0" / anything else → DISABLED (default).
 *
 * The default is false so production builds stay web-blocked unless the
 * variable is explicitly provided; enable it only on development servers.
 * Frontend-only restriction — the native Capacitor apps are never affected.
 */
const WEB_ATTENDANCE_RAW = String(
  process.env.REACT_APP_ENABLE_WEB_ATTENDANCE ?? "",
)
  .trim()
  .toLowerCase();
export const IS_WEB_ATTENDANCE_ENABLED =
  WEB_ATTENDANCE_RAW === "true" || WEB_ATTENDANCE_RAW === "1";

/**
 * True when the Attendance Tablet role must be blocked on the current device:
 * running on the web (not inside the native Capacitor app) AND the
 * REACT_APP_ENABLE_WEB_ATTENDANCE flag above is disabled.
 * Use this everywhere the old `!Capacitor.isNativePlatform()` tablet gate was.
 */
export const isWebAttendanceBlocked = (): boolean =>
  !Capacitor.isNativePlatform() && !IS_WEB_ATTENDANCE_ENABLED;
//** Function to get Captcha site key */
export const getCAPTCHASiteKey = (value: string) => {
  const finalKey = value!.slice(18, 58);
  return finalKey;
};

//** Function to get backend API  key */
export const getAPIKey = (value: string) => {
  const finalKey = value!.slice(9, 253);
  return finalKey;
};

/** Environment */
// Set below key and url accroding to your project
// export const API_KEY = import.meta.env.VITE_API_KEY;
// export const API_URL = import.meta.env.VITE_API_URL;

// For dev server set alias
export let API_URL: string = process.env.REACT_APP_API_URL || "";
export let BACKEND_DOMAIN: string;
export let API_KEY: string = DecriptEnv(process.env.REACT_APP_API_KEY || "");
export let BUCKET_URL: string;
export let STORE_URL: string;
export let PROFILE_URL: string;
export let STATIC_PAGE_URL: string;
export let USER_SAMPLE_CSV: string;
export let INSERT_BASE_CSV: string;
export let CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export let Image_URL: any = process.env.REACT_APP_S3_BASE_PATH;
export let Sample_Csv_Url: any = process.env.REACT_APP_CSV_SAMPLE_BASE_URL;
export let UNDER_DEVELOPMENT_SECTION_DISBALED: any =
  process.env.REACT_APP_UNDER_DEVELOPMENT_SECTION_DISABLED;
export let IS_DEV = process.env.REACT_APP_IS_DEV || 0;

export let googleMapApiKEy: string = DecriptEnv(
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
);
export const SOCET_CONNECTION_URL = process.env.REACT_APP_SOCKET_CONNECTION_URL;
export const SOCKET_CONNECTION_PATH =
  process.env.REACT_APP_SOCKET_CONNECTION_PATH;

/** User Roles */
export const ROLE = {
  ADMIN: "admin",
  USER: "user",
  SUB_ADMIN: "sub-admin",
  SALES_MANAGER: "sales-manager",
  SALES: "sales",
  ACCOUNTS: "accounts",
  PRODUCTION_MANAGER: "production-manager",
  PRODUCTION_TEAM: "production-team",
  INSTALLATION_MANAGER: "installation-manager",
  INSTALLATION: "installation-team",
  DISPATCH_MANAGER: "dispatch-manager",
  DISPATCH: "dispatch-team",
  CLIENT: "client",
  DISTRIBUTOR: "distributor",
  DESIGN_TEAM: "design-team",
  HR: "hr",
  HR_MANAGER: "hr-manager",
  ATTENDANCE_TABLET: "attendance-tablet",
  PRINTING_MANAGER: "printing-manager",
  CREDIT_CONTROLLER: "credit-controller",
  SEO: "seo",
  STORE_EXECUTIVE: "store-executive",
};

export const DASHBOARD_ROLES = [
  ROLE.ADMIN,
  ROLE.SUB_ADMIN,
  ROLE.ACCOUNTS,
  ROLE.SALES_MANAGER,
  ROLE.SALES,
  ROLE.PRODUCTION_MANAGER,
  ROLE.PRODUCTION_TEAM,
  ROLE.INSTALLATION_MANAGER,
  ROLE.INSTALLATION,
  ROLE.DISPATCH_MANAGER,
  ROLE.DISPATCH,
  ROLE.PRINTING_MANAGER,
  ROLE.CLIENT,
  ROLE.DISTRIBUTOR,
  ROLE.HR_MANAGER,
  ROLE.HR,
];

export const isDashboardRole = (role?: any): boolean => {
  if (!role) return false;
  if (typeof role === "string") return DASHBOARD_ROLES.includes(role);
  if (typeof role === "object") {
    if (role.dashboard_type !== undefined) {
      return !!role.dashboard_type && role.dashboard_type !== "none";
    }
    return !!role.key && DASHBOARD_ROLES.includes(role.key);
  }
  return false;
};

export const getDefaultDashboardByRoleKey = (roleKey?: string): string => {
  switch (roleKey) {
    case ROLE.ADMIN:
    case ROLE.SUB_ADMIN:
      return "admin_dashboard";
    case ROLE.ACCOUNTS:
      return "finance_dashboard";
    case ROLE.SALES_MANAGER:
    case ROLE.SALES:
      return "sales_dashboard";
    case ROLE.PRODUCTION_MANAGER:
    case ROLE.PRODUCTION_TEAM:
      return "production_dashboard";
    case ROLE.INSTALLATION_MANAGER:
    case ROLE.INSTALLATION:
      return "installation_dashboard";
    case ROLE.DISPATCH_MANAGER:
    case ROLE.DISPATCH:
      return "dispatch_dashboard";
    case ROLE.CLIENT:
    case ROLE.DISTRIBUTOR:
      return "customer_dashboard";
    case ROLE.HR_MANAGER:
    case ROLE.HR:
      return "hr_dashboard";
    case ROLE.PRINTING_MANAGER:
      return "printing_manager_dashboard";
    default:
      return "";
  }
};

export const hasAllDashboardAccess = (role?: any): boolean => {
  if (!role) return false;
  const roleKey = typeof role === "string" ? role : role?.key;
  const dashboardType = typeof role === "object" ? role?.dashboard_type : null;
  return (
    roleKey === ROLE.ADMIN ||
    roleKey === ROLE.SUB_ADMIN ||
    dashboardType === "all"
  );
};

export const accessMultipleAccount = [ROLE.CLIENT, ROLE.DISTRIBUTOR];

export const INVOICE_WARNING_VISIBLE_ROLES = [
  ROLE.ADMIN,
  ROLE.SUB_ADMIN,
  ROLE.ACCOUNTS,
  ROLE.SALES_MANAGER,
  ROLE.SALES,
];
/** Common Variables */
//  export const EMAIL_REGEX = /^[\w+-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const ONLY_NUMBERS_REGEX = /^[0-9]+$/;
export const ONLY_ALPHABETS_REGEX = /^[A-Za-z ]+$/;
export const allowedExtensions = [
  "pdf",
  "jpeg",
  "jpg",
  "png",
  "gif",
  "bmp",
  "ico",
  "svg",
  "heif",
  "apng",
  "avif",
  "webp",
  "tiff",
];
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/** Date Functions Starts */
export const dayjsFormat = "DD-MM-YYYY";
export const dayjsFormatTime = "DD-MM-YYYY hh:mm A";
export const lifetimeDate = new Date(dayjs("01-01-2024").format(dayjsFormat));
const day = new Date(dayjs("01-01-2024").format(dayjsFormat)).getDate();
const month = new Date(dayjs("01-01-2024").format(dayjsFormat)).getMonth() + 1;
const year = new Date(dayjs("01-01-2024").format(dayjsFormat)).getFullYear();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const momentDDMMYY = (data: any) => moment(data).format(dayjsFormat);
export const momentFullTime = (data: any) =>
  moment(data).format("DD-MM-YYYY, hh:mm A");
export const momentDateTime = (data: moment.MomentInput) =>
  moment(data).format(dayjsFormatTime);

/**
 * Calculates Dispatch Date working backwards from On-Site Delivery Date by allowanceDays.
 * Excludes weekends (Saturday & Sunday).
 * If deliveryDate is empty or invalid, returns null.
 */
export const calculateDispatchDate = (
  deliveryDate: any,
  allowanceDays: number = 0,
): Dayjs | null => {
  if (!deliveryDate) return null;
  const d = dayjs(deliveryDate);
  if (!d.isValid()) return null;

  let daysToSubtract = Number(allowanceDays) || 0;
  if (daysToSubtract <= 0) return d;

  let current = d;
  while (daysToSubtract > 0) {
    current = current.subtract(1, "day");
    const dayOfWeek = current.day(); // 0 is Sunday, 6 is Saturday
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysToSubtract--;
    }
  }
  return current;
};

export const lifetimeDateWithFormat = `${year}-${month < 9 ? `0${month}` : month
  }-${day < 9 ? `0${day}` : day}`;

export const dateFormat = "DD-MM-YYYY";
export const dateFormatWithTime = "DD-MM-YYYY, hh:mm A";

export const rightsReserved = "© 2024 SoloAtSea LLC. All rights reserved.";

export const rangePresets: TimeRangePickerProps["presets"] | undefined = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
  { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
];

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
export const DefaultProfileImage = DefaultProfile;
export const DefaultNoImageFound = allCommonImages?.emptyImage;
export const imageCompressorFn = async (
  file: any,
  setState: any,
  setLoader?: any,
) => {
  const options = {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    if (setLoader) {
      setLoader(true);
    }
    const compFile = await imageCompression(file, options);
    if (setLoader) {
      setLoader(false);
    }
    setState(compFile);
  } catch (error) {
    setState(file);
  }
};

export function CapitalizeFirstWord(text: any) {
  if (!text) return "";
  return text;
  // return text
  //   .split(" ")
  //   .map(
  //     (word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  //   )
  //   .join(" ");
}



export const rangePickerProps = {
  bordered: false,
  format: dayjsFormat,
  style: { width: "100%", height: "100%" },
  // suffixIcon: svg?.dashBoardDownArrow,
  className: "antdRangePicker ff",
  separator: svg?.DashboardDateRange,
  placeholder: ["Start Date", "End Date"],
};

// export const rangePresets = [
//   { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
//   { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
//   { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
//   { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
// ];

export const PermissionChecker = (
  roleName: string,
  PermissionsArray: any,
  permission: any,
) => {
  if (roleName == ROLE?.ADMIN) {
    return true;
  } else if (PermissionsArray?.includes(permission)) {
    return true;
  } else {
    return false;
  }
};

export const USER_DEFAULT_PERMISSIONS_ARRAY: any = {
  READ: "read",
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  APPROVE: "approve",
  FOR_ALL_USER: "access_of_all_user",
  CHANGE_STATUS: "change_status",
  ESTIMATE_APPROVE_DECLINE: "estimate_approve_and_decline",
  INVOICE_APPROVE_DECLINE: "invoice_approve_and_decline",
  ACCEPT_PAYMENT: "accept_payment",
};

export const AccessiblePermission = (
  roleName: string,
  PermissionsArray: any,
) => {
  const { user }: any = useAppSelector((state: RootState) => state.auth);

  const Read_Permission = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY.READ,
  );
  const Add_Permission = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY.ADD,
  );
  const Edit_Permission = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY.EDIT,
  );
  const Delete_Permission = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY.DELETE,
  );
  const Approve_Permission = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.APPROVE,
  );
  const ForAllUser = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.FOR_ALL_USER,
  );
  const Change_Status = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.CHANGE_STATUS,
  );
  const EstimateApproveDeclient = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.ESTIMATE_APPROVE_DECLINE,
  );
  const InvoiceApproveDeclient = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.INVOICE_APPROVE_DECLINE,
  );
  const AcceptPay = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.ACCEPT_PAYMENT,
  );
  const is_admin = roleName == ROLE?.ADMIN ? true : false;
  const is_customer = user?.is_customer ? true : false;
  return {
    READ: Read_Permission,
    ADD: Add_Permission,
    EDIT: Edit_Permission,
    DELETE: Delete_Permission,
    APPROVE: Approve_Permission,
    FOR_ALL_USER: ForAllUser,
    CHANGE_STATUS: Change_Status,
    ADMIN: is_admin,
    ESTIMATE_APPROVE_DECLINE: EstimateApproveDeclient,
    INVOICE_APPROVE_DECLINE: InvoiceApproveDeclient,
    ACCEPT_PAY: AcceptPay,
    IS_CUSTOMER: is_customer,
  };
};

interface SorterState {
  field: string | null;
  order: "asc" | "desc" | null;
}

/**
 * Converts backend sort state (asc/desc) to Ant Design sort order (ascend/descend)
 * @param columnKey The key of the column to check
 * @param sorterState The current state object containing field and order
 * @returns 'ascend' | 'descend' | null
 */
export const getAntdSortOrder = (
  columnKey: string,
  sorterState: SorterState,
): SortOrder => {
  if (sorterState.field === columnKey && sorterState.order) {
    return sorterState.order === "asc" ? "ascend" : "descend";
  }
  return null;
};

/**
 *
 * @param dateInput - The date to format (String, Date object, or Timestamp)
 * @param withTime - Whether to include the time in the output format
 * @returns The formatted date string, or an empty string if input is invalid/missing
 */
export function formatToLocalDate(
  dateInput: string | Date | number | null | undefined,
  withTime: boolean = false,
): string {
  try {
    if (!dateInput) return "";

    let parsedDate: Dayjs;

    // 1. If it is a real JS Date object
    if (dateInput instanceof Date) {
      parsedDate = dayjs(dateInput);
    }
    // 2. If it is a String
    else if (typeof dateInput === "string") {
      // Safe to use .endsWith now since we ensured it is a string
      const isUTC = dateInput.endsWith("Z");

      // If 'Z' is present, parse as UTC then convert to Local.
      // Otherwise, parse as Local directly.
      parsedDate = isUTC ? dayjs.utc(dateInput).local() : dayjs(dateInput);
    }
    // 3. Fallback (e.g. timestamp numbers)
    else {
      parsedDate = dayjs(dateInput);
    }

    // Optional: Check validity to prevent "Invalid Date" string in UI
    if (!parsedDate.isValid()) return "";

    const formatString = withTime ? dateFormatWithTime : dateFormat;
    return parsedDate.format(formatString);
  } catch (error) {
    console.error("[formatToLocalDate] Error formatting date:", error);
    return "";
  }
}

export const getFullAwsUrl = (path: string, appendVersion: boolean = false) => {
  if (!path) return "";
  if (path.startsWith("http"))
    return appendVersion
      ? path + "?v=" + process.env.REACT_APP_IMAGE_VERSION
      : path; // Already full URL (legacy data)

  // Construct standard AWS URL
  const bucket = DecriptEnv(process.env.REACT_APP_AWS_BUCKET_NAME);
  const region = DecriptEnv(process.env.REACT_APP_AWS_REGION);
  return appendVersion
    ? `https://${bucket}.s3.${region}.amazonaws.com/${path}?v=${process.env.REACT_APP_IMAGE_VERSION}`
    : `https://${bucket}.s3.${region}.amazonaws.com/${path}`;
};

export const getThumbnailUrl = (path: string) => {
  if (!path) return "https://placehold.co/40?text=S";
  if (path.startsWith("http")) return path;

  const bucket = DecriptEnv(process.env.REACT_APP_AWS_BUCKET_NAME);
  const region = DecriptEnv(process.env.REACT_APP_AWS_REGION);
  const baseUrl = `https://${bucket}.s3.${region}.amazonaws.com`;
  // Swap folder "services/" for "thumbnails/"
  const fileName = path.split("/").pop();
  return `${baseUrl}/thumbnails/${fileName}`;
};

export const capitalizeFirstLetter = (
  str: string | null | undefined,
): string => {
  if (!str) return "";
  return str;
  // return str.charAt(0).toUpperCase() + str.slice(1);
};

export const TeamMemberCommitionRole = ["sales"];

// Define the interface based on your backend response
export interface AddressType {
  address?: string; // Street/Line 1
  city?: string;
  state?: string;
  zipcode?: string;
  country?: any;
  [key: string]: any; // Allow other props like lat/lng
}

export interface DeliveryAddressType {
  address?: string; // Street/Line 1
  city?: string;
  area_id: {
    area_name: string;
    prefix?: string;
  };
  delivery_country_id: {
    country_name: string;
  };
  state?: string;
  zipcode?: string;
  country?: string;
  [key: string]: any; // Allow other props like lat/lng
}

/**
 * Formats an address object into a single comma-separated string.
 * Filters out null, undefined, or empty values.
 */
export const formatAddress = (addr: AddressType | null | undefined): string => {
  if (!addr) return "-";
  const countryStr =
    typeof addr.country === "object" && addr.country !== null
      ? addr.country?.name || ""
      : addr.country || "";

  const parts = [
    addr.address,
    addr.city,
    addr.state,
    countryStr,
    addr.zipcode,
  ];

  const formatted = parts
    .filter((part) => part && typeof part === "string" && part.trim() !== "")
    .join(", ");

  return formatted || "-";
};

export const formatDeliveryAddress = (
  addr: DeliveryAddressType | null | undefined,
): string => {
  if (!addr) return "-";

  const parts = [
    addr.address,
    addr.city ? addr.city : addr.area_id?.area_name,
    addr.state ? addr.state : addr.delivery_country_id?.country_name,
    addr.zipcode,
  ];

  const formatted = parts
    .filter((part) => part && part.trim() !== "")
    .join(", ");

  return formatted || "-";
};

export const ATTRIBUTE_ORDER = [
  { key: "height", label: "Height (mm)" },
  { key: "front_upright_height", label: "Front Upright Height (mm)" },
  { key: "rear_upright_height", label: "Rear Upright Height (mm)" },
  { key: "reinforced_height", label: "Reinforced Height (mm)" },
  { key: "width", label: "Width (mm)" },
  { key: "depth", label: "Depth (mm)" },
  { key: "length", label: "Length (mm)" },
  { key: "thickness", label: "Thickness (mm)" },
  { key: "gauge", label: "Gauge (mm)" },
  { key: "level_width", label: "Level Width (mm)" },
  { key: "level_depth", label: "Level Depth (mm)" },
  { key: "bolts_per_footplate", label: "Bolts per Footplate" },
  { key: "dividers_per_shelf", label: "Dividers per Shelf" },
  { key: "connecting_points", label: "Connecting Points" },
  { key: "holes_drilled", label: "Holes Drilled" },
  { key: "first_beam_level", label: "1st Beam Level (mm)" },
  { key: "frame_type", label: "Frame Type" },
  { key: "foot_type", label: "Foot Type" },
  { key: "shelf_reinforcers", label: "Shelf Reinforcers" },
  { key: "crossties", label: "Crossties" },
  { key: "pallet_supports", label: "Pallet Supports" },
  { key: "chipboard_supports", label: "Chipboard Supports" },
  { key: "v_type", label: "Type" },
  { key: "drop", label: "Drop" },
  { key: "custom_drop", label: "Custom Drop (mm)" },
  { key: "first_shelf_level", label: "1st Shelf Level (mm)" },
  { key: "finish", label: "Finish" },
  { key: "color", label: "Color" },
  { key: "secondary_finish", label: "Secondary Finish" },
  { key: "secondary_color", label: "Secondary Color" },
];

/** User Roles */
export const CREATE_MEMBER_RESTRICT_ROLE = [
  "admin",
  "distributor",
  "customer",
  "client",
  "supplier",
];

export const UniqueByIdForDropdown = (arr: any[]) => [
  ...new Map(arr.filter(Boolean).map((i) => [i._id, i])).values(),
];

export const RightsReservedString = `© ${new Date()?.getFullYear() || "2026"
  } SPERRIN METAL. All rights reserved.`;

/**
 * Reusable GBP Formatter (Memoized)
 */
const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats a value to GBP.
 * Handles numbers, strings that look like numbers, and nullish fallbacks.
 * * @param amount - The value to be formatted.
 * @returns A formatted string e.g., "£1,234.56"
 */
export const formatGBP = (
  amount: number | string | null | undefined,
): string => {
  // Convert to number and fallback to 0 if the value is nullish or NaN
  const numericValue = typeof amount === "string" ? parseFloat(amount) : amount;

  // Logical OR handles 0, null, undefined, and NaN
  const safeValue = numericValue || 0;

  return gbpFormatter.format(safeValue);
};

export const normalizeCurrencyCode = (currency?: string | null): string => {
  if (!currency) return "GBP";
  const trimmed = String(currency).trim().toUpperCase();
  if (trimmed === "£" || trimmed === "POUND" || trimmed === "POUNDS")
    return "GBP";
  if (trimmed === "€" || trimmed === "EURO" || trimmed === "EUR") return "EUR";
  if (trimmed === "$" || trimmed === "DOLLAR" || trimmed === "USD")
    return "USD";
  if (trimmed === "FRF") return "GBP";
  if (/^[A-Z]{3}$/.test(trimmed)) return trimmed;
  return "GBP";
};

export const formatCurrency = (
  amount: number | string | null | undefined,
  currency: string = "GBP",
  customConversionRate?: number,
): string => {
  const numericValue = typeof amount === "string" ? parseFloat(amount) : amount;
  let safeValue = numericValue || 0;
  const validCurrency = normalizeCurrencyCode(currency);

  if (validCurrency !== "GBP") {
    if (customConversionRate !== undefined) {
      safeValue = safeValue * customConversionRate;
    } else if (store) {
      const state = store.getState();
      const conversionRate =
        state.quotation?.quotationDetails?.conversion_rate ||
        state.orders?.orderDetails?.conversion_rate ||
        state.estimation?.estimationDetails?.conversion_rate ||
        1;
      safeValue = safeValue * conversionRate;
    }
  }

  try {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: validCurrency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatter.format(safeValue);
  } catch (error) {
    console.error("formatCurrency error for currency:", currency, error);
    const sym = getCurrencySymbol(validCurrency) || "£";
    return `${sym}${safeValue.toFixed(2)}`;
  }
};

export const getCurrencySymbol = (currency?: string | null): string => {
  if (!currency) return "";
  const normalized = normalizeCurrencyCode(currency);
  switch (normalized) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    default:
      return "";
  }
};

export const countryOptions = [
  { label: "England", value: "England" },
  { label: "Republic of Ireland", value: "Republic of Ireland" },
  { label: "Wales", value: "Wales" },
  { label: "Scotland", value: "Scotland" },
  { label: "Northern Ireland", value: "Northern Ireland" },
];

export const countryPrefixMap: Record<
  string,
  { value: string; label: string }[]
> = {
  Scotland: [
    { value: "AB", label: "Aberdeen" },
    { value: "CA", label: "Carlisle" },
    { value: "DD", label: "Dundee" },
    { value: "DG", label: "Dumfries" },
    { value: "EH", label: "Edinburgh" },
    { value: "FK", label: "Falkirk" },
    { value: "G", label: "Glasgow" },
    { value: "HS", label: "Stornoway" },
    { value: "IV", label: "Inverness" },
    { value: "KA", label: "Kilmarnock" },
    { value: "KW", label: "Kirkwall" },
    { value: "KY", label: "Kirkcaldy" },
    { value: "ML", label: "Motherwell" },
    { value: "NE", label: "Newcastle upon Tyne" },
    { value: "PA", label: "Paisley" },
    { value: "PH", label: "Perth" },
    { value: "TD", label: "Galashiels" },
    { value: "ZE", label: "Lerwick" },
  ],

  England: [
    { value: "AB", label: "Aberdeen" },
    { value: "AL", label: "St Albans" },
    { value: "B", label: "Birmingham" },
    { value: "BA", label: "Bath" },
    { value: "BB", label: "Blackburn" },
    { value: "BD", label: "Bradford" },
    { value: "BH", label: "Bournemouth" },
    { value: "BL", label: "Bolton" },
    { value: "BN", label: "Brighton" },
    { value: "BR", label: "Bromley" },
    { value: "BS", label: "Bristol" },
    { value: "BT", label: "Belfast" },
    { value: "CA", label: "Carlisle" },
    { value: "CB", label: "Cambridge" },
    { value: "CF", label: "Cardiff" },
    { value: "CH", label: "Chester" },
    { value: "CM", label: "Chelmsford" },
    { value: "CO", label: "Colchester" },
    { value: "CR", label: "Croydon" },
    { value: "CT", label: "Canterbury" },
    { value: "CV", label: "Coventry" },
    { value: "CW", label: "Crewe" },
    { value: "DA", label: "Dartford" },
    { value: "DD", label: "Dundee" },
    { value: "DE", label: "Derby" },
    { value: "DG", label: "Dumfries" },
    { value: "DH", label: "Durham" },
    { value: "DL", label: "Darlington" },
    { value: "DN", label: "Doncaster" },
    { value: "DT", label: "Dorchester" },
    { value: "DY", label: "Dudley" },
    { value: "E", label: "East London" },
    { value: "EC", label: "East Central London" },
    { value: "EH", label: "Edinburgh" },
    { value: "EN", label: "Enfield" },
    { value: "EX", label: "Exeter" },
    { value: "FK", label: "Falkirk" },
    { value: "FY", label: "Blackpool" },
    { value: "G", label: "Glasgow" },
    { value: "GL", label: "Gloucester" },
    { value: "GU", label: "Guildford" },
    { value: "HA", label: "Harrow" },
    { value: "HD", label: "Huddersfield" },
    { value: "HG", label: "Harrogate" },
    { value: "HP", label: "Hemel Hempstead" },
    { value: "HR", label: "Hereford" },
    { value: "HS", label: "Hebrides" },
    { value: "HU", label: "Hull" },
    { value: "HX", label: "Halifax" },
    { value: "IG", label: "Ilford and Gants Hill" },
    { value: "IP", label: "Ipswich" },
    { value: "IV", label: "Inverness" },
    { value: "KA", label: "Kilmarnock" },
    { value: "KT", label: "Kingston upon Thames" },
    { value: "KW", label: "Kirkwall" },
    { value: "KY", label: "Kirkcaldy" },
    { value: "L", label: "Liverpool" },
    { value: "LA", label: "Lancaster" },
    { value: "LD", label: "Llandrindod Wells" },
    { value: "LE", label: "Leicester" },
    { value: "LL", label: "Llandudno" },
    { value: "LN", label: "Lincoln" },
    { value: "LS", label: "Leeds" },
    { value: "LU", label: "Luton" },
    { value: "M", label: "Manchester" },
    { value: "ME", label: "Medway" },
    { value: "MK", label: "Milton Keynes" },
    { value: "ML", label: "Motherwell" },
    { value: "N", label: "North London" },
    { value: "NE", label: "Newcastle upon Tyne" },
    { value: "NG", label: "Nottingham" },
    { value: "NN", label: "Northampton" },
    { value: "NP", label: "Newport" },
    { value: "NR", label: "Norwich" },
    { value: "NW", label: "North West London" },
    { value: "OL", label: "Oldham" },
    { value: "OX", label: "Oxford" },
    { value: "PA", label: "Paisley" },
    { value: "PE", label: "Peterborough" },
    { value: "PH", label: "Perth" },
    { value: "PL", label: "Plymouth" },
    { value: "PO", label: "Portsmouth" },
    { value: "PR", label: "Preston" },
    { value: "RG", label: "Reading" },
    { value: "RH", label: "Redhill" },
    { value: "RM", label: "Romford" },
    { value: "S", label: "Sheffield" },
    { value: "SA", label: "Swansea" },
    { value: "SE", label: "South East London" },
    { value: "SG", label: "Stevenage" },
    { value: "SK", label: "Stockport" },
    { value: "SL", label: "Slough" },
    { value: "SM", label: "Sutton" },
    { value: "SN", label: "Swindon" },
    { value: "SO", label: "Southampton" },
    { value: "SP", label: "Salisbury Plain" },
    { value: "SR", label: "Sunderland" },
    { value: "SS", label: "Southend-on-Sea" },
    { value: "ST", label: "Stoke-on-Trent" },
    { value: "SW", label: "South West London" },
    { value: "SY", label: "Shrewsbury" },
    { value: "TA", label: "Taunton" },
    { value: "TD", label: "Galashiels" },
    { value: "TF", label: "Telford" },
    { value: "TN", label: "Tunbridge Wells" },
    { value: "TQ", label: "Torquay" },
    { value: "TR", label: "Truro" },
    { value: "TS", label: "Teesside" },
    { value: "TW", label: "Twickenham" },
    { value: "UB", label: "Uxbridge" },
    { value: "W", label: "West London" },
    { value: "WA", label: "Warrington" },
    { value: "WC", label: "West Central London" },
    { value: "WD", label: "Watford" },
    { value: "WF", label: "Wakefield" },
    { value: "WN", label: "Wigan" },
    { value: "WR", label: "Worcester" },
    { value: "WS", label: "Walsall" },
    { value: "WV", label: "Wolverhampton" },
    { value: "YO", label: "York" },
    { value: "ZE", label: "Lerwick" },
  ],

  Wales: [
    { value: "CF", label: "Cardiff" },
    { value: "LL", label: "Llandudno" },
    { value: "NP", label: "Newport" },
    { value: "SA", label: "Swansea" },
  ],

  "Northern Ireland": [{ value: "BT", label: "Belfast" }],

  "Republic of Ireland": [
    { value: "D", label: "Dublin" },
    { value: "C", label: "Cork" },
    { value: "G", label: "Galway" },
    { value: "L", label: "Limerick" },
  ],
};

export const getFeePercentage = (
  total: number,
  transactionFee: number,
): number => {
  if (!total || transactionFee <= 0) return 0;

  // Calculate original amount before fee
  const originalAmount = total - transactionFee;

  if (originalAmount <= 0) return 0;

  return Number(((transactionFee / originalAmount) * 100).toFixed(2));
};

export const getCurrencyDisplayLabel = (currency?: string | null): string => {
  if (!currency) return "";
  const normalized = normalizeCurrencyCode(currency);
  const symbol = getCurrencySymbol(normalized);
  return symbol ? `${symbol}(${normalized})` : `(${normalized})`;
};

export const getCurrencyOptions = () => {
  const options = [
    { label: "GBP (£)", value: "GBP" },
    { label: "EUR (€)", value: "EUR" },
  ];
  const hostname = window.location.hostname;
  if (
    hostname === "localhost" ||
    hostname.startsWith("192.168.") ||
    hostname.includes("dev")
  ) {
    options.push({ label: "USD ($)", value: "USD" });
  }
  return options;
};

export const isInvoiceFeatureEnabled =
  process.env.REACT_APP_ENABLE_INVOICES === "1" ||
  process.env.REACT_APP_ENABLE_INVOICES === "true";

/**
 * Helper to get a cookie value by name.
 */
export const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") return null;
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
};

/**
 * Helper to set a cookie with expiration in days.
 */
export const setCookie = (name: string, value: string, days = 365 * 5) => {
  if (typeof document === "undefined") return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

/**
 * Returns a unique, persistent device ID:
 * - Mobile App: Uses localStorage & Capacitor Device.getId()
 * - Web: Uses persistent Cookie (with seamless localStorage fallback/migration)
 */
export const getDeviceId = async (): Promise<string> => {
  try {
    // 📱 MOBILE APP (Capacitor iOS/Android)
    if (Capacitor.isNativePlatform()) {
      let deviceId = localStorage.getItem("device_id");
      if (deviceId) {
        return deviceId;
      }

      const idInfo = await Device.getId();
      if (idInfo?.identifier) {
        deviceId = idInfo.identifier;
      } else {
        deviceId =
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : "mob_" +
            Math.random().toString(36).substring(2, 15) +
            Date.now().toString(36);
      }

      localStorage.setItem("device_id", deviceId);
      return deviceId;
    }

    // 🌐 WEB BROWSER
    let deviceId = getCookie("device_id");
    if (deviceId) {
      return deviceId;
    }

    // Check if user already had a device_id in localStorage from previous login and migrate to cookie
    const existingLocalId = localStorage.getItem("device_id");
    if (existingLocalId) {
      deviceId = existingLocalId;
      setCookie("device_id", deviceId);
      return deviceId;
    }

    // Generate new unique device ID for web
    deviceId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "web_" +
        Math.random().toString(36).substring(2, 15) +
        Date.now().toString(36);

    setCookie("device_id", deviceId);
    return deviceId;
  } catch (error) {
    console.error("Error getting device id:", error);
    return (
      getCookie("device_id") ||
      localStorage.getItem("device_id") ||
      "unknown_device"
    );
  }
};

// ---- WCAG 2.1 Luminance, Perceived Brightness & Department Theme Helpers ----
export const parseColorToRgb = (
  colorStr?: string,
): [number, number, number] => {
  if (!colorStr) return [24, 144, 255]; // fallback blue
  const str = colorStr.trim().toLowerCase();
  if (str === "white" || str === "transparent") return [255, 255, 255];
  if (str === "black") return [0, 0, 0];

  // Handle hex (#rgb, #rgba, #rrggbb, #rrggbbaa)
  if (str.startsWith("#")) {
    let hex = str.slice(1);
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split("")
        .slice(0, 3)
        .map((c) => c + c)
        .join("");
    } else if (hex.length >= 6) {
      hex = hex.slice(0, 6);
    }
    if (hex.length === 6) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      if (!isNaN(r) && !isNaN(g) && !isNaN(b)) {
        return [r, g, b];
      }
    }
  }

  // Handle rgb / rgba
  const rgbMatch = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (rgbMatch) {
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);
    if (!isNaN(r) && !isNaN(g) && !isNaN(b)) {
      return [r, g, b];
    }
  }

  // Handle hsl / hsla
  const hslMatch = str.match(/hsla?\((\d+),\s*([\d.]+)%,\s*([\d.]+)%/i);
  if (hslMatch) {
    const h = parseInt(hslMatch[1], 10) / 360;
    const s = parseFloat(hslMatch[2]) / 100;
    const l = parseFloat(hslMatch[3]) / 100;
    const hue2rgb = (p: number, q: number, t: number) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = Math.round(hue2rgb(p, q, h + 1 / 3) * 255);
    const g = Math.round(hue2rgb(p, q, h) * 255);
    const b = Math.round(hue2rgb(p, q, h - 1 / 3) * 255);
    return [r, g, b];
  }

  return [24, 144, 255];
};

export const getRelativeLuminance = (
  r: number,
  g: number,
  b: number,
): number => {
  const rs = r / 255;
  const gs = g / 255;
  const bs = b / 255;

  const rLum = rs <= 0.04045 ? rs / 12.92 : Math.pow((rs + 0.055) / 1.055, 2.4);
  const gLum = gs <= 0.04045 ? gs / 12.92 : Math.pow((gs + 0.055) / 1.055, 2.4);
  const bLum = bs <= 0.04045 ? bs / 12.92 : Math.pow((bs + 0.055) / 1.055, 2.4);

  return 0.2126 * rLum + 0.7152 * gLum + 0.0722 * bLum;
};

export const getContrastRatio = (lum1: number, lum2: number): number => {
  const lighter = Math.max(lum1, lum2);
  const darker = Math.min(lum1, lum2);
  return (lighter + 0.05) / (darker + 0.05);
};

export const getDepartmentTagTheme = (colorStr?: string) => {
  const deptColor = colorStr || "#1890ff";
  const [r, g, b] = parseColorToRgb(deptColor);
  const lum = getRelativeLuminance(r, g, b);

  // Check if color is white or near-white (high luminance and low saturation)
  const isSimilarToWhite =
    lum >= 0.82 && Math.max(r, g, b) - Math.min(r, g, b) <= 30;

  if (isSimilarToWhite) {
    return {
      backgroundColor: "#000000",
      textColor: "#ffffff",
      borderColor: "#000000",
      inactiveBg: "rgba(0, 0, 0, 0.05)",
      inactiveBorder: "rgba(0, 0, 0, 0.15)",
      inactiveText: "#231f20",
      isLight: false,
      isSimilarToWhite: true,
    };
  }

  // Perceived brightness formula (W3C / ITU-R BT.601)
  // Ensures red, blue, purple, dark green get white text, while bright colors (yellow, gray, cyan) get black text
  const perceivedBrightness = (r * 299 + g * 587 + b * 114) / 1000;
  const textColor = perceivedBrightness >= 140 ? "#000000" : "#ffffff";
  const isLight = textColor === "#000000";

  // Inactive text: full opacity, high-contrast legible tone matching the color
  let inactiveText = deptColor;
  if (r > 200 && g < 60 && b < 60) {
    inactiveText = "#a8071a"; // deep crimson for red (matching Pending Logs)
  } else if (r < 60 && g < 160 && b > 200) {
    inactiveText = "#0853cf"; // deep blue (matching Time-Off Requests)
  } else if (r < 100 && g > 150 && b < 60) {
    inactiveText = "#237804"; // deep green
  } else if (r > 180 && g > 100 && b < 40) {
    inactiveText = "#874d00"; // deep amber
  } else if (perceivedBrightness >= 90) {
    const factor = 85 / perceivedBrightness;
    inactiveText = `rgb(${Math.round(r * factor)}, ${Math.round(
      g * factor,
    )}, ${Math.round(b * factor)})`;
  }

  return {
    backgroundColor: deptColor,
    textColor,
    borderColor: isLight ? "rgba(0, 0, 0, 0.18)" : deptColor,
    inactiveBg: `rgba(${r}, ${g}, ${b}, 0.12)`,
    inactiveBorder: `rgba(${r}, ${g}, ${b}, 0.35)`,
    inactiveText,
    isLight,
    isSimilarToWhite: false,
  };
};

export const generateDeptTabsStyle = (
  className: string,
  departments: any[],
  activeKey?: string,
): string => {
  if (!departments || departments.length === 0) return "";

  const rules = departments
    .map((dept: any) => {
      const id = dept?._id?._id || dept?._id;
      const idStr = id?.toString();
      if (!idStr) return "";

      const deptColor = dept.color || "#1890ff";
      const theme = getDepartmentTagTheme(deptColor);

      return `
        .${className} .ant-tabs-tab[data-node-key="${idStr}"] {
          background-color: ${theme.backgroundColor} !important;
          border-right: 1px solid rgba(255, 255, 255, 0.3) !important;
          opacity: 1 !important;
          transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;
        }
        .${className} .ant-tabs-tab[data-node-key="${idStr}"] .ant-tabs-tab-btn {
          color: ${theme.textColor} !important;
          font-weight: 600 !important;
          opacity: 1 !important;
        }
        .${className} .ant-tabs-tab[data-node-key="${idStr}"]:hover {
          opacity: 0.9 !important;
        }
        .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="${idStr}"] {
          background-color: #231f20 !important;
          opacity: 1 !important;
        }
        .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="${idStr}"] .ant-tabs-tab-btn {
          color: #ffffff !important;
          opacity: 1 !important;
        }
      `;
    })
    .join("\n");

  const commonRules = `
    .${className} .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
      background: #231f20 !important;
    }
    .${className} .ant-tabs-tab[data-node-key="all"],
    .${className} .ant-tabs-tab[data-node-key="dispatch"] {
      background-color: #ffffff !important;
      border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
      opacity: 1 !important;
    }
    .${className} .ant-tabs-tab[data-node-key="all"] .ant-tabs-tab-btn,
    .${className} .ant-tabs-tab[data-node-key="dispatch"] .ant-tabs-tab-btn {
      color: #231f20 !important;
      font-weight: 600 !important;
      opacity: 1 !important;
    }
    .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="all"],
    .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="dispatch"] {
      background-color: #231f20 !important;
      opacity: 1 !important;
    }
    .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="all"] .ant-tabs-tab-btn,
    .${className} .ant-tabs-tab.ant-tabs-tab-active[data-node-key="dispatch"] .ant-tabs-tab-btn {
      color: #ffffff !important;
      opacity: 1 !important;
    }
  `;

  return rules + commonRules;
};

export enum StaticSalespersonOptionValue {
  CONTACTED_OFFICE = "contacted_office",
  REGULAR_CUSTOMER = "regular_customer",
}

export const StaticSalespersonOptionLabels: Record<
  StaticSalespersonOptionValue,
  string
> = {
  [StaticSalespersonOptionValue.CONTACTED_OFFICE]: "Contacted Office",
  [StaticSalespersonOptionValue.REGULAR_CUSTOMER]: "Regular Customer",
};

export const getStaticSalespersonOptions = () => {
  return Object.values(StaticSalespersonOptionValue).map((value) => ({
    label: StaticSalespersonOptionLabels[value],
    value,
  }));
};

export const getStaticSalespersonLabel = (key?: string | null): string => {
  if (!key) return "";
  return (
    StaticSalespersonOptionLabels[key as StaticSalespersonOptionValue] || ""
  );
};

export const getStaticSalespersonValue = (
  idOrLabel?: string | null,
): StaticSalespersonOptionValue | null => {
  if (!idOrLabel || typeof idOrLabel !== "string") return null;
  if (
    Object.values(StaticSalespersonOptionValue).includes(
      idOrLabel as StaticSalespersonOptionValue,
    )
  ) {
    return idOrLabel as StaticSalespersonOptionValue;
  }
  const entry = Object.entries(StaticSalespersonOptionLabels).find(
    ([, label]) => label.toLowerCase() === idOrLabel.toLowerCase(),
  );
  if (entry) {
    return entry[0] as StaticSalespersonOptionValue;
  }
  return null;
};

export const getLeadTimeOptions = () => {
  return Array.from({ length: 40 }, (_, i) => (i + 1) * 0.5).map((val) => ({
    value: val,
    label: `${val.toFixed(1)} ${val === 1 ? "Week" : "Weeks"}`,
  }));
};

export interface AllowanceYearOption {
  value: number;
  label: string;
}

export const getBusinessCurrentYear = (): number => {
  try {
    const tz = getBusinessTimeZone();
    return moment().tz(tz).year();
  } catch (e) {
    return dayjs().year();
  }
};

export const getBusinessDateYear = (date: any): number => {
  try {
    const tz = getBusinessTimeZone();
    const rawDate = date && typeof date.toDate === "function" ? date.toDate() : date;
    return moment(rawDate).tz(tz).year();
  } catch (e) {
    return dayjs(date).year();
  }
};

/**
 * Formats a year's label according to its relation with the business current year:
 * - currentYear - 1: "{year} (Last Year)" (e.g. "2025 (Last Year)")
 * - currentYear: "{year} (Current Year)" (e.g. "2026 (Current Year)")
 * - currentYear + 1: "{year} (Next Year)" (e.g. "2027 (Next Year)")
 * - other years: "{year}"
 */
export const formatYearLabel = (
  year: number | string,
  currentYear: number = getBusinessCurrentYear(),
): string => {
  const y = Number(year);
  if (isNaN(y)) return String(year);
  if (y === currentYear) {
    return `${y} (Current Year)`;
  }
  if (y === currentYear - 1) {
    return `${y} (Last Year)`;
  }
  if (y === currentYear + 1) {
    return `${y} (Next Year)`;
  }
  return `${y}`;
};

/**
 * Returns base system starting year depending on environment:
 * - Live: 2026
 * - Local & Dev: 2025
 */
export const getSystemStartYear = (): number => {
  const env = String(process.env.REACT_APP_ENV ?? "").trim().toLowerCase();
  return env === "live" ? 2026 : 2025;
};

/**
 * Returns Jan 1st of system starting year as Dayjs object
 */
export const getSystemStartDate = (): dayjs.Dayjs => {
  return dayjs(`${getSystemStartYear()}-01-01`).startOf("day");
};

/**
 * Generates year options for time off allowance based on environment:
 * - Always includes all system years from getSystemStartYear() up to currentYear.
 *   - On Live (starting year 2026): displays 2026 (Current Year).
 *   - On Dev/Local (starting year 2025): displays 2025 (Last Year) and 2026 (Current Year).
 * - Additional future years greater than currentYear are included if present in futureYears.
 */
export const getAllowanceYearOptions = (
  futureYears?: (number | string)[],
): AllowanceYearOption[] => {
  return buildAllowanceYearOptions(futureYears);
};

/**
 * Builds the complete allowance year options combining default window
 * and all distinct database allowance years, formatted and sorted chronologically:
 * - Always includes all system years from getSystemStartYear() up to currentYear:
 *   - When starting year is 2025 and availableYears is [2026]: displays 2025 (Last Year) & 2026 (Current Year).
 *   - When starting year is 2026 (Live) and availableYears is [2026]: displays only 2026 (Current Year).
 * - Any future years (e.g. 2027) are only included if present in availableYears.
 */
export const buildAllowanceYearOptions = (
  availableYears?: (number | string)[],
): AllowanceYearOption[] => {
  const currentYear = getBusinessCurrentYear();
  const systemStartYear = getSystemStartYear();
  const yearSet = new Set<number>();

  // Always include all system years from getSystemStartYear() up to currentYear
  for (let y = systemStartYear; y <= currentYear; y++) {
    yearSet.add(y);
  }

  // Include any extra/future years from availableYears that are >= systemStartYear
  if (Array.isArray(availableYears)) {
    availableYears.forEach((y) => {
      const num = Number(y);
      if (!isNaN(num) && num >= systemStartYear) {
        yearSet.add(num);
      }
    });
  }

  const sortedYears = Array.from(yearSet).sort((a, b) => a - b);

  return sortedYears.map((year) => ({
    value: year,
    label: formatYearLabel(year, currentYear),
  }));
};

/**
 * Generates descending year options for Employee Notes filters:
 * - Always includes system years from getSystemStartYear() to currentYear.
 * - Includes any additional years from availableYears.
 */
export const getNotesYearOptions = (
  availableYears?: (number | string)[],
): { value: string; label: string }[] => {
  const currentYear = getBusinessCurrentYear();
  const systemStartYear = getSystemStartYear();
  const yearSet = new Set<number>();

  for (let y = systemStartYear; y <= currentYear; y++) {
    yearSet.add(y);
  }

  if (Array.isArray(availableYears)) {
    availableYears.forEach((y) => {
      const num = Number(y);
      if (!isNaN(num) && num >= systemStartYear) {
        yearSet.add(num);
      }
    });
  }

  const sortedYears = Array.from(yearSet).sort((a, b) => b - a);

  return sortedYears.map((year) => ({
    value: year.toString(),
    label: formatYearLabel(year, currentYear),
  }));
};

/**
 * Generates year options for PTO History filter:
 * Includes "All", followed by years from getSystemStartYear() up to currentYear,
 * plus any extraYears passed in (all bounded by getSystemStartYear()).
 */
export const getPtoHistoryYearOptions = (
  extraYears?: (number | string)[],
): { value: string; label: string }[] => {
  const currentYear = getBusinessCurrentYear();
  const systemStartYear = getSystemStartYear();
  const options = [{ value: "", label: "All" }];
  const yearSet = new Set<number>();

  for (let y = systemStartYear; y <= currentYear; y++) {
    yearSet.add(y);
  }

  if (Array.isArray(extraYears)) {
    extraYears.forEach((y) => {
      const num = Number(y);
      if (!isNaN(num) && num >= systemStartYear) {
        yearSet.add(num);
      }
    });
  }

  const sortedYears = Array.from(yearSet).sort((a, b) => a - b);
  sortedYears.forEach((y) => {
    options.push({
      value: y.toString(),
      label: formatYearLabel(y, currentYear),
    });
  });

  return options;
};


